import {
  ApplicationProvider,
  ApplicationProviderProps,
} from './ApplicationProvider';
import { RoutesContainer } from './RoutesContainer';
import 'highcharts/highcharts-more';
import 'highcharts/modules/annotations';
import 'highcharts/modules/map';
import 'highcharts/modules/exporting';

type RootProps = Omit<ApplicationProviderProps, 'children'> & {
  basePath?: string;
  impersonationAccessToken?: string;
};

const Root = (props: RootProps) => (
  <ApplicationProvider {...props}>
    <RoutesContainer basename={props.basePath} />
  </ApplicationProvider>
);

export default Root;
